import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bug, LifeBuoy, Lightbulb } from "lucide-react";
import { DashboardSectionHeader } from "src/components/common";
import HelpSupportCard from "./HelpSupportCard";
import PageFeedbackForm from "./PageFeedbackForm";
import GeneralSupport from "./GeneralSupport";
import "./HelpSupport.scss";

type SectionKey = "reportBug" | "featureRequest" | "generalSupport";

const HelpSupport: FC = () => {
  const { t } = useTranslation();
  const [openSection, setOpenSection] = useState<SectionKey | null>(null);

  const toggleSection = (section: SectionKey) => {
    setOpenSection(prev => (prev === section ? null : section));
  };

  return (
    <div className="help-support-page">
      <DashboardSectionHeader
        title={t("helpSupport.title")}
        subtitle={t("helpSupport.subtitle")}
      />

      <HelpSupportCard
        icon={<Bug size={18} />}
        iconVariant="bug"
        title={t("helpSupport.reportBug.title")}
        subtitle={t("helpSupport.reportBug.subtitle")}
        isOpen={openSection === "reportBug"}
        onToggle={() => toggleSection("reportBug")}
      >
        <PageFeedbackForm namespace="reportBug" />
      </HelpSupportCard>

      <HelpSupportCard
        icon={<Lightbulb size={18} />}
        iconVariant="feature"
        title={t("helpSupport.featureRequest.title")}
        subtitle={t("helpSupport.featureRequest.subtitle")}
        isOpen={openSection === "featureRequest"}
        onToggle={() => toggleSection("featureRequest")}
      >
        <PageFeedbackForm namespace="featureRequest" />
      </HelpSupportCard>

      <HelpSupportCard
        icon={<LifeBuoy size={18} />}
        iconVariant="support"
        title={t("helpSupport.generalSupport.title")}
        subtitle={t("helpSupport.generalSupport.subtitle")}
        isOpen={openSection === "generalSupport"}
        onToggle={() => toggleSection("generalSupport")}
      >
        <GeneralSupport />
      </HelpSupportCard>
    </div>
  );
};

export default HelpSupport;
